import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 20a8 8 0 100-16 8 8 0 000 16zm2.364-12l1.414 1.414-1.414 1.414-1.414-1.414L14.364 8zm-2.121 2.121l1.414 1.415-3.536 3.535H8.707v-1.414l3.536-3.536z" }));
export default createSvgIcon(iconPath, "Drafted");
//# sourceMappingURL=StatusDraftedIcon.js.map